import batteryImage from '../assets/images/battery.jpg';
import brakesImage from '../assets/images/brakes.jpg';
import acRepairImage from '../assets/images/ac-repair.jpg';
import engineImage from '../assets/images/engine.jpg';
import diagnosingImage from '../assets/images/diagnosing.jpg';
import tyresImage from '../assets/images/tyres.jpg';

// Static fallback images mapped by slug
const serviceImagesBySlug = {
  'minor-service': diagnosingImage,
  'major-service': engineImage,
  'standard-minor-service': diagnosingImage,
  'comprehensive-major-service': engineImage,
  'logbook-service': engineImage,
  'general-service': diagnosingImage,
  'brake-suspension': brakesImage,
  'brakes-clutch-suspension': brakesImage,
  'brakes-clutch-and-suspension': brakesImage,
  'brakes-clutch': brakesImage,
  'aircon-service': acRepairImage,
  'air-conditioning': acRepairImage,
  'ac-service': acRepairImage,
  'ac-repair': acRepairImage,
  'tyres-alignment': tyresImage,
  'tyres-wheel-alignment': tyresImage,
  'tyre-service': tyresImage,
  'tyres': tyresImage,
  'battery-service': batteryImage,
  'battery': batteryImage,
  'mechanical-works': engineImage,
  'mechanical-services': engineImage,
  'engine-service': engineImage,
};

/**
 * Get the appropriate image for a service based on API data or fallback
 * @param {Object} service - Service object from API
 * @param {string} slug - Service slug (optional, used for fallback)
 * @returns {string} Image URL or imported image
 */
export const getServiceImage = (service, slug = null) => {
  // First priority: API-provided image on the service itself
  if (service?.image && service.image.trim()) {
    return service.image;
  }

  // Second priority: API-provided image on the category
  if (service?.category?.image && service.category.image.trim()) {
    return service.category.image;
  }

  // Third priority: Slug-based fallback
  const serviceSlug = slug || service?.slug;
  if (serviceSlug) {
    // Try exact slug match
    if (serviceImagesBySlug[serviceSlug]) {
      return serviceImagesBySlug[serviceSlug];
    }

    // Try normalized slug (remove common prefixes/suffixes)
    const normalizedSlug = serviceSlug
      .replace(/^standard-/, '')
      .replace(/^comprehensive-/, '')
      .replace(/-package$/, '');
    if (serviceImagesBySlug[normalizedSlug]) {
      return serviceImagesBySlug[normalizedSlug];
    }
  }

  // Fourth priority: Name-based detection
  if (service?.name) {
    const serviceName = service.name.toLowerCase();
    if (serviceName.includes('brake') || serviceName.includes('clutch') || serviceName.includes('suspension')) {
      return brakesImage;
    }
    if (
      serviceName.includes('aircon') ||
      serviceName.includes('air-conditioning') ||
      serviceName.includes('air conditioning') ||
      serviceName.includes('a/c') ||
      serviceName.includes('ac ')
    ) {
      return acRepairImage;
    }
    if (serviceName.includes('tyre') || serviceName.includes('tire') || serviceName.includes('wheel') || serviceName.includes('alignment')) {
      return tyresImage;
    }
    if (serviceName.includes('battery')) {
      return batteryImage;
    }
    if (serviceName.includes('engine') || serviceName.includes('mechanical') || serviceName.includes('major')) {
      return engineImage;
    }
  }

  // Default fallback
  return diagnosingImage;
};

export default getServiceImage;
